"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCommwebService = exports.useCommwebServiceClient = void 0;
const vue_1 = require("vue");
const injection_symbols_1 = require("./injection-symbols");
function useCommwebServiceClient() {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return (0, vue_1.inject)(injection_symbols_1.commwebServiceClientKey);
}
exports.useCommwebServiceClient = useCommwebServiceClient;
function useCommwebService() {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return (0, vue_1.inject)(injection_symbols_1.commwebServiceKey);
}
exports.useCommwebService = useCommwebService;
//# sourceMappingURL=use-api.js.map